import { render, staticRenderFns } from "./InquiryValue.vue?vue&type=template&id=83dd6f84&scoped=true"
import script from "./InquiryValue.vue?vue&type=script&lang=ts"
export * from "./InquiryValue.vue?vue&type=script&lang=ts"
import style0 from "./InquiryValue.vue?vue&type=style&index=0&id=83dd6f84&lang=css"
import style1 from "./InquiryValue.vue?vue&type=style&index=1&id=83dd6f84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dd6f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83dd6f84')) {
      api.createRecord('83dd6f84', component.options)
    } else {
      api.reload('83dd6f84', component.options)
    }
    module.hot.accept("./InquiryValue.vue?vue&type=template&id=83dd6f84&scoped=true", function () {
      api.rerender('83dd6f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/InquiryValue.vue"
export default component.exports